import * as props from './props';

export const Icon = {
    name: 'Icon',
    props: {
        type: props.type,
        withSelection: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        shape() {
            return shapes[this.type];
        },
        circleOptions() {
            return circleOptions[this.type];
        },
        selectedCircleOptions() {
            return selectedCircleOptions[this.type];
        },
        markOptions() {
            return markOptions[this.type];
        }
    },
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="168" height="144" viewBox="0 0 168.125 144"
     class="parcel-type__icon__image">
     <path  class="parcel-type__icon__shape" :d="shape"/>
        <template v-if="withSelection">
            <circle class="parcel-type__icon__unselected" v-bind="circleOptions" r="18"/>
            <g class="parcel_type__icon__selected">
                <circle fill="#F8B906" stroke="#F8B906" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10" v-bind="selectedCircleOptions" cy="122.084" r="19"/>
                <path v-bind="markOptions" fill="none" stroke="#FFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M15.414 122.025l6.914 6.432 11.13-11.54"/>
            </g>
        </template>
     </svg>`
};

const shapes = {
    paleta: 'M131.9 111.896v15.694a2.842 2.842 0 0 0 2.834 2.835h28.757a2.842 2.842 0 0 0 2.835-2.835V96.602a2.843 2.843 0 0 0-2.835-2.836H19.829a2.843 2.843 0 0 0-2.835 2.836v30.99a2.842 2.842 0 0 0 2.835 2.835h29.33a2.842 2.842 0 0 0 2.835-2.835v-15.331c0-1.56 1.275-2.84 2.835-2.846l16.872-.062a2.83 2.83 0 0 1 2.835 2.824v15.413a2.842 2.842 0 0 0 2.835 2.835h28.746a2.842 2.842 0 0 0 2.835-2.835v-15.413a2.842 2.842 0 0 1 2.835-2.835h10.249M21.504 25.829l7.727-5.908c.559-.457 1.605-.83 2.326-.83h52.218c1.688 0 2.178.164 2.178 1.981l.076 63.035c0 .721-.59 1.311-1.311 1.311H18.304c-.72 0-1.31-.59-1.31-1.311V35.194c0-.721.59-1.311 1.31-1.311h57.329M97.292 26.028v-6.107c0-.83.04-.83 1.31-.83h53.471c.721 0 1.701.441 2.179.981l11.208 12.677c.479.539.868 1.57.868 2.291v49.067c0 .721-.591 1.311-1.312 1.311H98.602c-.721 0-1.31-.59-1.31-1.311V35.194c0-.721.589-1.311 1.31-1.311h57.328',
    paczka: 'M21.993 21.416l21.471-17.54c1.208-.986 3.471-1.793 5.03-1.793h86.998c1.56 0 3.68.955 4.713 2.123l24.244 27.42c1.033 1.168 1.878 3.398 1.878 4.958v90.998a2.842 2.842 0 0 1-2.835 2.834H146.41c-.916 0-.75.059-.75-1.5v-28.854c0-1.054-.114-.979.75-.979h6.416c2.521 0 2.543-.104 1.209-2.323L141.95 80.906c-1.572-2.109-1.65-2.078-3.322-.053L125.69 96.812c-1.469 2.063-1.446 2.271 1.138 2.271h6.832c1.125.042 1-.088 1 .979v28.854c0 1.56.125 1.5-1 1.5h-29.498c-.894 0-.835.113-.835-.834V99.918c0-.835-.08-.835.835-.835h6.664c2.614 0 2.459-.177 1.131-2.267l-11.761-15.635c-1.719-1.72-1.719-1.802-3.471-.05L84.177 96.867c-1.684 2.133-1.684 2.216 1.066 2.216h6.082c1.053 0 .834-.167.834.835v29.664c0 1.002-.095.834-.834.834H19.827a2.842 2.842 0 0 1-2.834-2.834V36.917a2.842 2.842 0 0 1 2.834-2.834h130.499',
    koperta: 'M166.256 68.76v58.832a2.842 2.842 0 0 1-2.835 2.835H19.757a2.842 2.842 0 0 1-2.834-2.835V36.929a2.842 2.842 0 0 1 2.834-2.835h143.665a2.842 2.842 0 0 1 2.835 2.835v8.992c0 1.56-1.104 3.472-2.456 4.25l-69.755 40.17c-1.351.778-3.517.706-4.813-.159l-55.29-36.956M23.922 123.089l36.666-36.667M159.422 123.089l-36.666-36.667'
};

const circleOptions = {
    koperta: {
        cx: "21.922",
        cy: "122.084"
    },
    paczka: {
        cx: "22.153",
        cy: "122.084"
    },
    paleta: {
        cx: "21.196",
        cy: "122.084"
    }
};

const selectedCircleOptions = {
    koperta: {
        cx: "21.773"
    },
    paczka: {
        cx: "22.004"
    },
    paleta: {
        cx: "21.004"
    }
};

const markOptions = {
    koperta: {
        transform: 'translate(-1 0)'
    },
    paczka: {
        transform: 'translate(-1 0)'
    },
    paleta: {
        transform: 'translate(-2 0)'
    }
}